import { z } from 'zod';
import { createNumericKeyRecordSchema } from '../KeyRecordSchemas.ts';
import { createPartialStrictObjectSchemaWithAtLeastOneProperty } from '../PartialStrictObjectSchema.ts';
import { validateState } from '../ValidateState.ts';
import { PlayerColor } from '../PlayerState.ts';
// TileEdgeDirection: https://prntscr.com/w5qsqr
export var TileEdgeDirection = /*#__PURE__*/ function(TileEdgeDirection) {
    TileEdgeDirection[TileEdgeDirection["NorthWest"] = 0] = "NorthWest";
    TileEdgeDirection[TileEdgeDirection["West"] = 1] = "West";
    TileEdgeDirection[TileEdgeDirection["SouthWest"] = 2] = "SouthWest";
    return TileEdgeDirection;
}({});
export var TileEdgeType = /*#__PURE__*/ function(TileEdgeType) {
    TileEdgeType[TileEdgeType["Road"] = 1] = "Road";
    TileEdgeType[TileEdgeType["Ship"] = 2] = "Ship";
    return TileEdgeType;
}({});
export const tileEdgeStateSchema = z.object({
    x: z.number().int().readonly(),
    y: z.number().int().readonly(),
    z: z.enum(TileEdgeDirection).readonly(),
    owner: z.union([
        z.enum(PlayerColor).exclude([
            'None'
        ]),
        z.null()
    ]).exactOptional(),
    type: z.union([
        z.enum(TileEdgeType),
        z.null()
    ]).exactOptional()
}).strict();
export function validateTileEdgeState(data) {
    return validateState(tileEdgeStateSchema, data);
}
export const tileEdgeStatesSchema = createNumericKeyRecordSchema(tileEdgeStateSchema);
export function validateTileEdgeStates(data) {
    return validateState(tileEdgeStatesSchema, data);
}
export const tileEdgeStatePartialSchema = createPartialStrictObjectSchemaWithAtLeastOneProperty(tileEdgeStateSchema);
export const tileEdgeStatesPartialSchema = createNumericKeyRecordSchema(tileEdgeStatePartialSchema, {
    requireAtLeastOneEntry: true
});
